import * as mutationTypes from "../../mutation-types";
import * as Utils from "../../../libraries/utils";
import {ApmHelper} from "../../../domains2/libraries/ApmHelper";

const state = {
	persistedData: {
		globalSelectedShop: null,
		globalSelectedShopRefreshToken: null
	},
	shopRedirectUrl: null
};

const getters = {
	globalSelectedShop: state => state.persistedData.globalSelectedShop,
	shopRedirectUrl: state => state.shopRedirectUrl,
	deliveryMethods: state => state.persistedData.globalSelectedShop ? state.persistedData.globalSelectedShop.deliveryMethods : [],
	globalSelectedShopRefreshToken: state => state.persistedData.globalSelectedShopRefreshToken,
	useRecommendations: (state, getters) => {
		return getters.globalSelectedShop
			&& getters.globalSelectedShop.shopOptions
			&& (getters.globalSelectedShop.shopOptions.recommendationEngineEnabled || getters.globalSelectedShop.shopOptions.recommendationEngineEnabledBasket)
			&& getters.featureToggles.recommendationEngine;
	},
	useCarousel: (state, getters) => {
		return getters.globalSelectedShop
			&& getters.globalSelectedShop.shopOptions
			&& getters.globalSelectedShop.shopOptions.recommendationEngineEnabledCarousel
			&& getters.featureToggles.recommendationEngine;
	},
	doMarketingCardsRecommendations: (state, getters) => {
		return getters.globalSelectedShop
			&& getters.globalSelectedShop.shopOptions
			&& getters.globalSelectedShop.shopOptions.recommendationEngineEnabledMarketingCard
			&& getters.featureToggles.recommendationEngine;
	}
};

const actions = {
	async setGlobalSelectedShop({ commit, getters, dispatch }, shop) {
		if (getters.globalSelectedShop && getters.globalSelectedShop.id === shop.id) {
			// if there is already global selected shop and it is the same as passed shop skip everything
			return;
		}

		commit(mutationTypes.SET_GLOBAL_SELECTED_SHOP, shop);

		// empty the basket products that are not allowed for this shop
		// make sure that product catalog is loaded, otherwise empty the cart
		const cartProducts = getters.cartProducts || [];
		const productCatalog = getters.productCatalog;
		if(cartProducts.length) {
			const productIds = productCatalog && productCatalog.products.length
				? cartProducts.map(
					selection => productCatalog.getProduct(selection.productId)
				).filter(product => {
					return Array.isArray(product.assortmentRules) &&
      product.assortmentRules.length > 0 &&
      product.assortmentRules.some(assortmentRule => assortmentRule.shopId === shop.id);
				}).map(p => p.id)
				: cartProducts.map(cp => cp.productId); // remove all products if product catalog is not loaded
			await dispatch(mutationTypes.REMOVE_FROM_CART, productIds);
		}

		ApmHelper.addLabel("shopId", shop.id);
		ApmHelper.addLabel("shortShopId", shop.id.split("-")[4]);
	},
	resetGlobalSelectedShop({ commit }) {
		commit(mutationTypes.SET_GLOBAL_SELECTED_SHOP, null);

		ApmHelper.addLabel("shopId", "");
		ApmHelper.addLabel("shortShopId", "");
	}
};

const mutations = {
	[mutationTypes.SET_GLOBAL_SELECTED_SHOP](state, shop) {
		state.persistedData.globalSelectedShop = Utils.copyObject(shop);
	},
	[mutationTypes.UNSET_GLOBAL_SELECTED_SHOP](state) {
		state.persistedData.globalSelectedShop = null;
	},
	[mutationTypes.SET_REDIRECT_URL](state, redirectUrl) {
		state.shopRedirectUrl = redirectUrl;
	},
	[mutationTypes.SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN] (state, shopRefreshToken) {
		state.persistedData.globalSelectedShopRefreshToken = shopRefreshToken;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
